import { Menu, Transition } from '@headlessui/react';
import { SetPointDropdownType } from '../../types/SetpointManagerTypes';
import React from 'react';

type DropdownProps = {
  options: SetPointDropdownType[];
  buttonText: string;
  onChange: (value: string) => void;
  value?: string | number | null;
  className?: string;
};
const ControllerValueDropdown = ({ options, buttonText, onChange, value, className }: DropdownProps) => {
  const text = options.find((option) => option.value === value)?.text || buttonText;
  return (
    <Menu
      as='div'
      className={`toggle-dropdown-container bg-black rounded-lg py-1.5 px-2 ${className ? className : ''}`}
      data-testid='view-options-component'
    >
      {({ open, close }) => (
        <>
          <div>
            <Menu.Button style={{ width: '100%' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'right',
                  width: '100%',
                }}
              >
                <span className='dropdown-value-content'>{text}</span>
                <span className={open ? 'fas fa-caret-up' : 'fas fa-caret-down'} />
              </div>
            </Menu.Button>
          </div>

          <Transition
            as={React.Fragment}
            enter='transition ease-out duration-100'
            enterFrom='transform opacity-0 scale-95'
            enterTo='transform opacity-100 scale-100'
            leave='transition ease-in duration-75'
            leaveFrom='transform opacity-100 scale-100'
            leaveTo='transform opacity-0 scale-95'
          >
            <Menu.Items className='w-20 absolute right-0 z-10 mt-2 whitespace-nowrap origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus-outline-none pointer'>
              <div className='dropdown-switches'>
                {options.map((option, index) => (
                  <div key={index} className='flex items-center'>
                    <div
                      className='dropdown-list'
                      style={{
                        width: '100%',
                        overflow: 'hidden',
                      }}
                      onClick={() => {
                        onChange(String(option.value));
                        close();
                      }}
                    >
                      <span
                        data-testid='view-option-label'
                        className='font-medium text-gray-900'
                        style={{
                          whiteSpace: 'normal',
                          wordWrap: 'break-word',
                        }}
                      >
                        {option.text}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
};
export default ControllerValueDropdown;
